import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';
import { MessageComponent } from './message/message.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { AddMessageComponent } from './add-message/add-message.component';
import { Store } from '@ngxs/store';
import { MessagesState } from '@app/app/store/messages/messages.state';
import { ActivatedRoute } from '@angular/router';
import { LoadersModule } from '../loaders/loaders.module';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  imports: [
    AddMessageComponent,
    CommonModule,
    LoadersModule,
    MatButtonModule,
    MatIconModule,
    MessageComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagesComponent {
  dealId = input.required<number>();

  msgIdParam = this.activatedRoute.snapshot.queryParamMap.get('msg');
  replyIdParam = this.activatedRoute.snapshot.queryParamMap.get('rpl');

  messages = this.store.selectSignal(MessagesState.messages);
  messagesAreLoading = this.store.selectSignal(MessagesState.loading);

  messageContainingReply = computed(() => {
    return this.messages().find((msg) =>
      msg.task_comments?.some((rpl) => rpl.id.toString() === this.replyIdParam)
    );
  });
  replyIdToHighlight = computed(() => {
    if (this.replyIdParam && this.messageContainingReply()) {
      return this.replyIdParam;
    }
  });
  messageIdToHighlight = computed(() => {
    return this.messages().find((msg) => msg.id.toString() === this.msgIdParam)?.id;
  });

  isAddingMessage = signal(false);

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store
  ) {}

  addFirstMessage(event: MouseEvent) {
    // Don’t actually try to navigate away
    event.preventDefault();
    this.isAddingMessage.set(true);
  }
}
